import { dynamicEditorComponent } from '@doltech/utils/lib/dynamicWithProps/dynamicEditorComponent';
import * as React from 'react';
import { RenderElementProps } from 'slate-react';

import { SlatePlugin } from '../../../../../slatePlugins/slatePlugins.types';
import { ViewVocabFlowPluginOptions } from '../types';
import { ELEMENT_VOCAB_FLOW } from './ViewVocabFlowPlugin.types';
import { withDynamicBlogEditorPluginHydration } from '@doltech/core/lib/hooks/withDolHydrationOnDemand';
import { ViewVocabFlowReadOnlyPlugin } from './ViewVocabFlowReadOnlyPlugin';

const ViewVocabFlowElement = withDynamicBlogEditorPluginHydration({ canInteract: true })(
  dynamicEditorComponent(() =>
    import('../components/ViewVocabFlowElement').then((mod) => mod.ViewVocabFlowElement)
  )
);

export const ViewVocabFlowPlugin = (options: ViewVocabFlowPluginOptions = {}): SlatePlugin => {
  if (options.isReadOnly) {
    return ViewVocabFlowReadOnlyPlugin(options);
  }

  return {
    inlineTypes: [ELEMENT_VOCAB_FLOW],
    renderElement: (renderProps: RenderElementProps) => {
      const { element } = renderProps;

      if (element?.type === ELEMENT_VOCAB_FLOW) {
        return <ViewVocabFlowElement {...renderProps} {...options} />;
      }

      return undefined;
    },
  };
};
